<p-toolbar>
  <div class="p-toolbar-group-start">
    <p-button label="Sync"
              icon="pi pi-sync"
              class="p-button-primary mr-2"
              (click)="onSyncClick()"
              [loading]="isSyncing">
    </p-button>
  </div>
</p-toolbar>

<p-table #dt
         dataKey="id"         
         [value]="(data$ | async)!"
         [loading]="(isLoading$ | async)!"
         [totalRecords]="(dataCount$ | async)!"
         [lazy]="true"
         [rows]="10"
         [showCurrentPageReport]="true"
         [rowsPerPageOptions]="[10, 25, 50]"
         [paginator]="true"
         [globalFilterFields]="['location.Id', 'location.Desc', 'location.ShortDesc']"
         [filterDelay]="250"
         [breakpoint]="'960px'"
         [rowHover]="true"
         (onLazyLoad)="onLazyLoad($event)"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
         sortField="location.Id"
         sortMode="single"
         responsiveLayout="stack">
  <ng-template pTemplate="caption">
    <div class="flex">
      Locations
      <span class="p-input-icon-left ml-auto">
        <i class="pi pi-search"></i>
        <input pInputText type="text" placeholder="Search keyword" (input)="applyFilterGlobal($event)" />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="min-width:15rem" pSortableColumn="location.Id">
        <div class="flex align-items-center">
          Id
          <p-sortIcon field="location.Id"></p-sortIcon>
          <p-columnFilter type="text" field="location.Id" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="min-width:15rem" pSortableColumn="location.ShortDesc">
        <div class="flex align-items-center">
          Short Description
          <p-sortIcon field="location.ShortDesc"></p-sortIcon>
          <p-columnFilter type="text" field="location.ShortDesc" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="min-width:15rem" pSortableColumn="location.Desc">
        <div class="flex align-items-center">
          Description
          <p-sortIcon field="location.Desc"></p-sortIcon>
          <p-columnFilter type="text" field="location.Desc" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="min-width:15rem" pSortableColumn="location.isDefault">
        <div class="flex align-items-center">
          Is Default
          <p-sortIcon field="location.isDefault"></p-sortIcon>
          <p-columnFilter type="text" field="location.isDefault" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="width: 8rem"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-location>
    <tr [ngClass]="{'deleted-record': location.deleteDate}">
      <td>
        <span class="p-column-title"><strong>Id</strong></span>
        {{location.Id}}
      </td>
      <td>
        <span class="p-column-title"><strong>Short Description</strong></span>
        {{location.ShortDesc}}
      </td>
      <td>
        <span class="p-column-title"><strong>Description</strong></span>
        {{location.Desc}}
      </td>
      <td>
        <span class="p-column-title"><strong>Is Default</strong></span>
        {{location.isDefault}}
      </td>
      <td style="text-align: center">
        <button pButton
                pRipple
                icon="pi pi-pencil"
                class="p-button-rounded p-button-primary mr-2"
                (click)="openEntity(location.Id)"
                pTooltip="Edit"
                tooltipPosition="left">
        </button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">No locations found.</td>
    </tr>
  </ng-template>
</p-table>
